export const TIME_OFF_PAGE_SIZE = 10;

export const reasonDict = {
  0: "Unknown",
  100: "Maternal",
  200: "Holiday",
  300: "Sick time",
  400: "Study",
};
